<template lang="html">
  <div>
    <!--
         <div class="pg-loader">
           <div class="pg-loader__image">
                <span class="pg-loader-lines">
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                  <span class="pg-loader-lines__item"></span>
                </span>
           </div>
         </div>
-->
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1>Úvod</h1>
      <h2 class="h2-welcome">Vítejte v Administraci Progresguru.</h2>
      <div class="content-wrap">
        <div class="content-wrap__half">
          <p>
            Počet knih v pořadníku:
            <strong>{{ downloads.ready }}</strong
            ><br />
            Počet aktuálně generovaných knih:
            <strong>{{ downloads.preparing }}</strong
            ><br />

          </p>
        </div>
        <div class="content-wrap__half">
        </div>
      </div>

      <h2 class="next-title">Statistiky</h2>
        <p v-if="!stats">Statistiky se načítají ..</p>
      <table width="340px" v-if="stats">
        <tr>
          <td>Období od - do</td>
          <td>
            <strong>{{ stats.from }} - {{ stats.to }}</strong>
          </td>
        </tr>
        <tr>
          <td>Počet objednávek</td>
          <td>
            <strong>{{ stats.sum_orders }}</strong>
          </td>
        </tr>
        <tr>
          <td>Celková cena</td>
          <td>
            <strong>{{ stats.sum_price }}</strong>
          </td>
        </tr>
        <tr>
          <td>Průměrná cena</td>
          <td>
            <strong>{{ stats.avg_price }}</strong>
          </td>
        </tr>
      </table>

      <v-row v-if="stats">
        <v-col cols="4">
          <v-text-field
            v-model="selectedMonth"
            type="month"
            placeholder="měsíc"
          />
        </v-col>
        <v-col>
          <v-btn @click="dashboardData" color="primary" size="small"
            >Zobrazit</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="stats">
        <v-col class="text-left">
          <!-- <v-btn
            @click="handleExport(itemsStats, stats.filename)"
            color="secondary"
            size="small"
            >Export</v-btn
          > -->
        <!--  <download-excel
            class="v-btn secondary control v-btn--contained theme--light v-size--default button--top"
            v-if="itemsStats"
            :data="itemsStats"
            :fields="stats.labels"
            type="xls"
            :name="stats.filename"
          >
            Exportovat
          </download-excel> -->
        </v-col>
      </v-row>
      <v-layout class="table-items" v-if="stats">
        <v-data-table
          locale="cs"
          :headers="headersStats"
          :items="itemsStats"
          :loading="false"
          :items-per-page="30"
          :mobile-breakpoint="0"
          hint="Vyberte měsíc"
          persistent-hint
          class="elevation-1 full-width frankjoy-table table-stats"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <td class="">{{ item.day }}</td>
                <td class="bolder small">
                  {{ item.sum_orders }}
                </td>
                <td class="bolder small">
                  {{ item.sum_price }}
                </td>
                <td class="bolder small">
                  {{ item.avg_price }}
                </td>
                <td class="bolder small right">
                  <!-- <download-excel
                    class="v-btn secondary control v-btn--contained theme--light v-size--default button--top"
                    :fields="labelsDayDetail"
                    type="xls"
                    :name="dailyItemsStats.find(d => d.day_sort === item.day_sort).filename"
                    :data="dailyItemsStats.find(d => d.day_sort === item.day_sort).results"
                  >
                    Exportovat
                  </download-excel> -->
                </td>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádné statistiky</p>
              </div>
            </tbody>
          </template>

          <template
            slot="footer"
            slot-scope="totals"
            v-if="itemsStats.length === 0"
            style="position:absolute;bottom:-44px;"
          >
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet statistik na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>
      <h2 class="next-title">Nejnovější objednávky</h2>

      <v-layout class="table-items">
        <v-data-table
          locale="cs"
          :headers="headers"
          :items="items"
          :loading="false"
          item-key="name"
          hide-default-footer
          :items-per-page="30"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{ name: 'OrdersDetail', params: { id: item.id } }"
                >
                  <td class="">{{ item.id }}</td>
                  <td class="bolder small">
                    {{ item.number
                    }}<span v-if="item.ios_receipt" class="apple-order"></span>
                  </td>
                  <td class="bold">
                    <router-link
                      :to="{
                        name: 'CustomersDetail',
                        params: { id: item.user_id },
                      }"
                    >
                      {{ item.user_forename }} {{ item.user_surname }}<br />
                      <span class="small normal">{{ item.user_email }}</span>
                    </router-link>
                  </td>
                  <td class="small">{{ formatCreatedAt(item.created_at) }}</td>
                  <td class="">{{ item.items_count }}</td>
                  <td class="bold">
                    <span v-if="item.price"> {{ item.price }} Kč </span>
                    <span v-else>
                      0 Kč
                    </span>
                    <br />
                    <span class="small normal"
                      >Bez DPH {{ item.price_no_dph }} Kč</span
                    >
                  </td>
                  <td class="small bold">
                    <span v-if="item.status === 'created'" class="status">{{
                      item.status_name
                    }}</span>
                    <span
                      v-else-if="item.status === 'canceled'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'storned'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'paid'"
                      class="status status--success"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'timeouted'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'refunded'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span v-else class="status status--normal"
                      ><span>{{ item.status_name }}</span></span
                    >
                  </td>
                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná objednávka nebyla nalezena</p>
              </div>
            </tbody>
          </template>
          <template slot="footer" slot-scope="totals" v-if="items.length === 0">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet objednávek na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'Dashboard',
  components: {},

  data() {
    return {
      selectedMonth: null,
      loaded: false,
      search: '',
      downloads: {
        ready: 0,
        preparing: 0,
      },
      labelsDayDetail: {
        Audiokniha: 'name',
        'Počet objednávek': 'sum_orders',
        'Celková cena': 'sum_price',
        'Průměrná cena': 'avg_price',
      },
      itemsStats: [],
      dailyItemsStats: [],
      items: [],
      stats: null,
      headersStats: [
        { text: 'Den', value: 'day_sort', align: 'left' },
        { text: 'Počet objednávek', value: 'sum_orders', align: 'left' },
        { text: 'Celková cena', value: 'sum_price', align: 'left' },
        { text: 'Průměrná cena', value: 'avg_price', align: 'left' },
        { text: '', value: 'export', align: 'left' },
      ],
      headers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: 'ID', value: 'id', align: 'left' },
        { text: 'Číslo objednávky', value: 'number', align: 'left' },
        { text: 'Zákazník', value: 'user_email', align: 'left' },
        { text: 'Vytvořeno', value: 'created_at', align: 'left' },
        { text: 'Počet produktů', value: 'items_count', align: 'left' },
        { text: 'Cena', value: 'price', align: 'left' },
        { text: 'Stav', value: 'status_name', align: 'left' },
        { text: '', value: 'controls', align: 'right' },
      ],
    };
  },

  async created() {
    this.fetchData();
    await this.dashboardData();
  },
  computed: {
    ...mapState(['profile']),
  },
  async mounted() {
    //await this.dashboardData();
  },
  methods: {
    handleExport(data, filename) {
      console.log({ data, filename });
    },
    goToDownloads() {
      this.$router.push({ name: 'Generating' });
    },
    formatCreatedAt(date) {
      if (date) {
        return moment.unix(date).format('D.M.YYYY - HH:mm');
      } else {
        return null;
      }
    },
    async dashboardData() {
      try {
        let url = '/admin/orders/dashboard';
        if (this.selectedMonth) {
          url += '?month=' + this.selectedMonth;
        }
        const data = await this.$axios.get(url);
        this.itemsStats = data.data.data.month_report;
        this.dailyItemsStats = data.data.data.daily_report;
        this.stats = {
          sum_orders: data.data.data.sum_orders,
          sum_price: data.data.data.sum_price,
          avg_price: data.data.data.avg_price,
          // sum_price: data.data.data.sum_price ? data.data.data.sum_price.replace(".", ",") : 0,
          // avg_price: data.data.data.avg_price ? data.data.data.avg_price.replace(".", ",") : 0,
          from: data.data.data.from,
          to: data.data.data.to,
          filename: data.data.data.filename,
          labels: {
            Den: 'day',
            'Počet objednávek': 'sum_orders',
            'Celková cena': 'sum_price',
            'Průměrná cena': 'avg_price',
          },
        };
        this.$forceUpdate();
      } catch (error) {
        console.error(error);
      }
    },
    fetchData() {
      this.$axios
        .get('/admin/orders/home')
        .then((response) => {
          response.data.orders.forEach((item) => {
            if (item.status === 'created') {
              item.status_name = 'Vytvořena';
            } else if (item.status === 'canceled') {
              item.status_name = 'Zrušena';
            } else if (item.status === 'storned') {
              item.status_name = 'Stornována';
            } else if (item.status === 'paid') {
              item.status_name = 'Zaplacena';
            } else if (item.status === 'timeouted') {
              item.status_name = 'Vypršela';
            } else if (item.status === 'refunded') {
              item.status_name = 'Platba vrácena';
            } else {
              if (item.status) {
                item.status_name = 'Neznámý - ' + item.status;
              } else {
                item.status_name = 'Neznámý';
              }
            }
          });

          this.items = response.data.orders;
          this.loaded = true;
        })
        .catch((e) => {
          this.loaded = true;
        });

      this.$axios
        .get('/admin/audiobooks/downloads/count')
        .then((response) => {
          this.downloads = response.data.downloads;
        })
        .catch((e) => {});
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.table-stats {
  margin-bottom: 10px;
}
.table-stats .v-data-footer {
  position: absolute;
  bottom: -44px !important;
}
</style>
